<template>
  <div id="preExamSet">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <ots-refer :selectList="selectList" :requestForm="requestForm" @search="search"></ots-refer>

    <el-tabs type="border-card" class="cards">

      <el-tab-pane label="考试基础设置">
        <el-form ref="formBasis" :model="form" label-width="200px" :rules="rules">
          <h3>基本设置</h3>
          <el-form-item label="考试方式设置：">
            <el-radio-group v-model="form.examType">
              <el-radio :label="1">
                机房断网
                <el-tooltip class="item" effect="dark" content="纯断网考试，考前、考中、考后都没有互联网" placement="right-start">
                  <i class="el-icon-warning" style="color: #606266;"></i>
                </el-tooltip>
              </el-radio>
              <el-radio :label="2">
                考中断网
                <el-tooltip class="item" effect="dark" content="考前考后可联网，仅在考中断网" placement="right-start">
                  <i class="el-icon-warning" style="color: #606266;"></i>
                </el-tooltip>
              </el-radio>
              <el-radio :label="3">公网</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考生登录方式设置：">
            <el-radio-group v-model="form.loginType">
              <el-radio :label="1">准考证登录</el-radio>
              <el-radio :label="2">身份证登录</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="提交试卷后显示成绩：" v-if="form.examType != 3">
            <el-switch v-model="form.submitPaperShowScore" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item v-show="form.submitPaperShowScore == 1" label="含主观题试卷提交后显示成绩">
            <!-- <template #label>
              <p style="height: 20px;" class="noUser">含主观题试卷提交后&nbsp;&nbsp;&nbsp;</p>
              <p style="height: 40px;" class="noUser">是否显示客观题成绩：</p>
            </template> -->
            <el-radio-group v-model="form.submitPaperShowScoreForSubjective">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="form.submitPaperShowScore == 1 && isShowSubCourseFlag" label="是否显示综合科目的单科成绩">
            <el-radio-group v-model="form.submitPaperShowScoreForSingle">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <template >

            <h3>人脸识别签到设置</h3>
            <el-form-item label="人脸识别签到：">
              <el-switch v-model="form.isSignState" :active-value="1" :inactive-value="0"></el-switch>
              <span class="machineTip" v-show="form.examType=='100'">(机房断网模式使用OIS签到)</span>
            </el-form-item>
            <el-form-item label="人脸识别考前允许签到时间：" v-if="form.isSignState == 1">
              <el-select v-model="form.allowSignStateTimeByBefore" placeholder="请选择活动区域">
                <el-option :label="item" :value="item" v-for="item in numList" :key="item"></el-option>
              </el-select>
              <span class="ml16">分钟</span>
            </el-form-item>
            <el-form-item label="人脸识别考后允许签到时间：" v-if="form.isSignState == 1">
              <el-select v-model="form.allowSignStateTimeByAfter" placeholder="请选择活动区域">
                <el-option :label="item" :value="item" v-for="item in numList" :key="item"></el-option>
              </el-select>
              <span class="ml16">分钟</span>
            </el-form-item>
            <el-form-item label="签到不通过允许人工判定：" v-if="form.isSignState == 1">
              <el-switch v-model="form.isCheckSignStateNoPass" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="签到时间已过允许签到：" v-if="form.isSignState == 1">
              <el-switch v-model="form.isSignStateOverTime" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="不刷身份证允许签到：" v-if="form.isSignState == 1">
              <el-switch v-model="form.isAllowedToSignWithoutIDCard" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item v-if="form.isSignState == 1">
              <template #label>
                <span>
                  <el-tooltip class="item" effect="dark" content="开启后会将考生基础照片与公安库照片做比对" placement="bottom">
                    <i class="el-icon-warning" style="color: #606266;"></i>
                  </el-tooltip>
                  签到开启权威库核身：
                </span>
              </template>
              <el-switch v-model="form.isSignStateByImageRecognition" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
              <p style="display: inline-block;" v-if="form.isSignStateByImageRecognition == 1">
                <span class="ml8 mr8 noUser">，每场权威库核身最多</span>
                <el-form-item prop="commitmentCountdownTime" style="display: inline-block;">
                  <el-select v-model="form.imageRecognitionTimes">
                    <el-option label="1" :value="1"></el-option>
                    <el-option label="2" :value="2"></el-option>
                    <el-option label="3" :value="3"></el-option>
                  </el-select>
                  <!-- <el-input v-model.number="form.commitmentCountdownTime"></el-input> -->
                </el-form-item>
                <span class="ml8 noUser">次</span>
              </p>
              </el-form-item>
              <!-- <el-form-item label="最晚作答时间：" prop="latestAnswerTime" v-if="form.isSignState == 0">
                <span class="mr8">开考后</span>
                <el-input v-model.number="form.latestAnswerTime"></el-input>
                <span class="ml8">分钟不允许进入（不能超过所设置场次的最大考试时长）</span>
              </el-form-item> -->
          </template>
          <!-- <template v-if="form.examType == 3 && [1, 2].includes(form.faceRecognitionType)"> -->
          <template v-if="false">
            <h3>防作弊设置</h3>
              <el-form-item  v-if="form.examType == 3">
              <template #label>
                <span>
                  <el-tooltip class="item" effect="dark" content="考生进入考试、提交试卷的验证方式" placement="bottom">
                    <i class="el-icon-warning" style="color: #606266;"></i>
                  </el-tooltip>
                  考前身份识别类型：
                </span>
              </template>
              <el-radio-group v-model="form.faceRecognitionType">
                <el-radio :label="1">人脸识别</el-radio>
                <el-radio :label="2">活体检测</el-radio>
                <el-radio :label="3">无需人脸识别</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="允许身份验证：">
              <el-form-item style="display: inline-block;" prop="faceRecognitionCount">
                <el-input v-model.number="form.faceRecognitionCount"></el-input>
              </el-form-item>
              <span class="ml8">次，学生身份验证不通过</span>
              <el-select v-model="form.isAllowExamByFaceRecognitionNoPass" placeholder="请选择" class="ml8">
                <el-option label="允许" :value="1"></el-option>
                <el-option label="不允许" :value="0"></el-option>
              </el-select>
              <span class="ml8">答卷。</span>
            </el-form-item>
            <el-form-item label="开启考中抓拍：">
              <el-switch v-model="form.takePhotoInTest" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="考中抓拍次数：" prop="autoPhotoTimes" v-if="form.takePhotoInTest == 1">
              <el-input v-model.number="form.autoPhotoTimes"></el-input>
              <span class="ml16">次（录入整数）</span>
            </el-form-item>
            <el-form-item label="开启抓拍强制交卷：" v-if="form.takePhotoInTest == 1">
              <el-switch v-model="form.isForceSubmitByAutoPhoto" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="抓拍几次不通过强制交卷：" v-if="form.isForceSubmitByAutoPhoto == 1 && form.takePhotoInTest == 1" prop="failedNTimesGoSubmit">
              <el-input v-model.number="form.failedNTimesGoSubmit"></el-input>
              <span class="ml16">次（录入整数，不能超过设置的考中抓拍次数）</span>
            </el-form-item>
          </template>

          <!-- <el-form-item label="显示考试倒计时：">
            <el-switch v-model="form.isShowCountdown" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item label="考前试卷密码同步时间：">
            <el-input v-model.number="form.paperPwdSyncTime"></el-input>
            <span class="ml16">分钟</span>
          </el-form-item> -->

          <el-form-item>
            <el-button type="primary" round @click="examSetSubmit('formBasis')" plain>确认保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="考试须知、承诺书设置">
        <el-form ref="formNotice" :model="noticeForm" label-width="200px" :rules="noticeRules">
          <h3>考试须知设置</h3>
          <el-form-item label="显示考试须知：">
            <el-switch v-model="noticeForm.isShowNotice" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="考试须知标题：" prop="noticeTitle" v-if="noticeForm.isShowNotice">
            <el-input v-model="noticeForm.noticeTitle" placeholder="请录入考试须知标题"></el-input>
          </el-form-item>
          <el-form-item label="考试须知内容：" v-if="noticeForm.isShowNotice">
            <!-- <el-input
              type="textarea"
              :rows="2"
              placeholder="请录入考试须知"
              v-model="noticeForm.noticeContent">
            </el-input> -->
            <ots-editor class="editor" v-model="noticeForm.noticeContent" />
          </el-form-item>

          <el-form-item label="考试须知是否开启倒计时：" v-if="noticeForm.isShowNotice">
            <el-switch v-model="noticeForm.isShowNoticeCountdown" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
            <p style="display: inline-block;" v-if="noticeForm.isShowNoticeCountdown == 1">
              <span class="ml8 mr8 noUser">，倒计时</span>
              <el-form-item style="display: inline-block;" prop="noticeCountdownTime">
                <el-input v-model.number="noticeForm.noticeCountdownTime"></el-input>
              </el-form-item>
              <span class="ml8 noUser">秒</span>
            </p>
          </el-form-item>

          <el-form-item label="考试须知按钮名称：" prop="noticeBtnText" v-if="noticeForm.isShowNotice">
            <el-input v-model="noticeForm.noticeBtnText" placeholder="请输入"></el-input>
          </el-form-item>

          <h3>考试承诺书设置</h3>
          <el-form-item label="显示考试承诺书：">
            <el-switch v-model="noticeForm.isShowCommitment" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="考试承诺书倒计时：" v-if="noticeForm.isShowCommitment">
            <el-switch v-model="noticeForm.isShowCommitmentCountdown" :active-value="1" :inactive-value="0"  active-text="开启" inactive-text="关闭"></el-switch>
            <p style="display: inline-block;" v-if="noticeForm.isShowCommitmentCountdown == 1">
              <span class="ml8 mr8 noUser">，倒计时</span>
              <el-form-item prop="commitmentCountdownTime" style="display: inline-block;">
                <el-input v-model.number="noticeForm.commitmentCountdownTime"></el-input>
              </el-form-item>
              <span class="ml8 noUser">秒</span>
            </p>
          </el-form-item>

          <el-form-item label="考试承诺书标题：" prop="commitmentTitle"  v-if="noticeForm.isShowCommitment">
            <el-input v-model="noticeForm.commitmentTitle" placeholder="请录入考试承诺书标题"></el-input>
          </el-form-item>
          <el-form-item label="考试承诺书内容："  v-if="noticeForm.isShowCommitment">
            <!-- <el-input
              type="textarea"
              :rows="2"
              placeholder="请录入考试承诺书内容"
              v-model="noticeForm.commitment">
            </el-input> -->
            <ots-editor class="editor" v-model="noticeForm.commitment" />
          </el-form-item>
        </el-form>
        <el-button type="primary" round @click="NoticeSubmit('formNotice')" plain style="margin-left: 200px;">确认保存</el-button>
      </el-tab-pane>

      <el-tab-pane label="考试机背底图片上传">
        <p class="title">考试机背底图片上传：<el-button round plain size="mini" @click="showIt" v-if="examBackgroundImageUrl">预览</el-button></p>
        <div style="display: flex; justify-content: left; align-items: center;">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :http-request="uploadImgUrl"
            :before-upload="beforeAvatarUpload">
            <img v-if="examBackgroundImageUrl" :src="examBackgroundImageUrl" class="avatar" style="width: 360px; height: auto; border: 1px solid transparent;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="margin-left: 36px; line-height: 36px;">
            <p>（1）图片支持jpg、jpeg、png</p>
            <p>（2）建议尺寸不小于800*600像素</p>
            <p>（3）文件大小不超过 5M</p>
          </div>
        </div>
        <el-button type="primary" round @click="uploadBackground" plain style="margin-top: 16px;">确认上传</el-button>
      </el-tab-pane>
    </el-tabs>

    <!-- <ots-custom-dialog :dialog.sync="showDialog" width="1344px" height="856px">
      <template v-slot:content>
        <div class="dialogImg" style="width: 756px;height: 756px; background: #ccc;">
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="showDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog> -->
  </div>  
</template>

<script>
import { getSelectPlanFn,getSinglePlan } from "@/http/modules/examSet/examBatch";
import { getPlanExamConfigAPI, saveExamConfigOneAPI, copyExamConfigAPI, saveExamConfigTwoAPI, saveExamConfigThreeAPI } from "@/http/modules/computedRoomExam";
/* 
  原型需求
  (1) 考试方式设置 => 选择'公网' => 显示'考前身份识别类型', 否则不显示;
  (2) 考试方式设置 => 选择'公网' => 显示'考中抓拍设置', 否则不显示; (考中抓拍设置涉及：开启考中抓拍、整个过程抓拍、开启抓拍强制交卷、抓拍几次不通过强制交卷)
  (3) 人脸识别签到 => 开启后显示 => 人脸识别考前允许签到时间、人脸识别考后允许签到时间、签到不通过允许人工判定、签到时间已过允许签到、签到开启权威库核身 => 关闭不显示
  (4) 人脸识别签到 => 开启后'不'显示 => 最晚作答时间 => 关闭后显示
  (5) 考前身份识别类型 => 选择了'无需人脸识别' => 不显示'防作弊设置'
  (6) 开启考中抓拍 => 开启 => 显示 '整个过程抓拍 X 次'
  (7) 开启抓拍强制交卷 => 开启 => 显示 '抓拍几次不通过强制交卷'
*/
export default {
  data() {
    return {
      numList: [60, 45, 30, 15],
      mainTopBtnList: [
        { title: '复制上个考试批次设置', fn: this.copyPrevious }
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
      ],
      requestForm: {
        planId: ""
      },
      form: {
        examType: '',                     // 考试方式设置
        loginType: "",                    // 考生登录方式设置
        faceRecognitionType: "",          // 考前身份识别类型
        isSignState: "",                  // 人脸识别签到
        allowSignStateTimeByAfter: 60,    // 人脸识别考前允许签到时间
        allowSignStateTimeByBefore: 60,   // 人脸识别考后允许签到时间
        isCheckSignStateNoPass: "",       // 签到不通过允许人工判定
        isSignStateOverTime: 1,           // 签到时间已过允许签到
        isAllowedToSignWithoutIDCard: 1,  // 不刷身份证允许签到
        isSignStateByImageRecognition: 1, // 签到开启权威库核身
        // isShowCountdown: 1,            // 显示考试倒计时
        // latestAnswerTime: 0,           // 最晚作答时间
        takePhotoInTest: "",              // 开启考中抓拍
        autoPhotoTimes: 0,                // 考中抓拍次数
        isForceSubmitByAutoPhoto: "",     // 开启抓拍强制交卷
        failedNTimesGoSubmit: 0,          // 抓拍几次不通过强制交卷
        // paperPwdSyncTime: "",          // 考前试卷密码同步时间
        faceRecognitionCount: '',         // 允许身份验证次数
        isAllowExamByFaceRecognitionNoPass: 1,  // 验证后是否允许报名
        imageRecognitionTimes: 1,        // 权威库核身次数
        submitPaperShowScore: 0,
        submitPaperShowScoreForSubjective: 1,
        submitPaperShowScoreForSingle : 0,
      },
      isShowSubCourseFlag : false,
      rules: {
        // latestAnswerTime: [
        //   {validator: this.blurText, trigger: 'blur'}
        // ],
        autoPhotoTimes: [
          {validator: this.blurText, trigger: 'blur'}
        ],
        failedNTimesGoSubmit: [
          {validator: this.blurText, trigger: 'blur'}
        ],
        faceRecognitionCount: [
          {validator: this.blurText, trigger: 'blur'}
        ]
      },
      noticeForm: {
        isShowNotice: "",
        noticeTitle: "",
        noticeContent: "",
        commitmentTitle: "",
        commitment: "",
        isShowNoticeCountdown: '',
        noticeCountdownTime: 10,
        noticeBtnText: '确定',
        isShowCommitment: '',
        isShowCommitmentCountdown: '',
        commitmentCountdownTime: '',
      },
      noticeRules: {
        noticeTitle: [
          { required: false, min: 0, max: 20, message: "考试须知标题最多20字", trigger: "blur" },
        ],
        commitmentTitle: [
          { required: false, min: 0, max: 20, message: "承诺书标题最多20字", trigger: "blur" }
        ],
        noticeBtnText: [
          { required: false, min: 0, max: 5, message: "考试须知按钮，最多五个字符", trigger: "blur" }
        ],
        commitmentCountdownTime: [
          {validator: this.blurText, trigger: 'blur'}
        ],
        noticeCountdownTime: [
          {validator: this.blurText, trigger: 'blur'}
        ]
      },
      examBackgroundImageUrl: "",
      // showDialog: false,
      previewBackgroundImage: "",
      planName: '',
    }
  },
  watch: {
    "requestForm.planId": function (newVal, oldVal) {
      let planName = '';
      this.selectList[0].data.some(e=>{
        if (e.id == newVal) {
          planName = e.name;
          return true;
        }
      })
      this.planName = planName;
      this.getPlanExamConfig();
    },
    "noticeForm.noticeTitle": function(val) {
      if (!val) {
        this.noticeForm.noticeTitle = "考试须知";
      }
    },
    "noticeForm.commitmentTitle": function(val) {
      if (!val) {
        this.noticeForm.commitmentTitle = "考试承诺书";
      }
    }
  },
  created() {
    this.getPlanList();
  },
  methods: {
    // 校验
    blurText(rule, value, callback) {  
      if (value || value == 0) {
        let reg = /^[1-9]\d*$/
        if (!reg.test(value)) {
          callback(new Error('请输入正整数！'));
        } else {
          callback();
        }
      } 
      callback();
    },

    // 批次下拉列表
    async getPlanList() {
      const { data: planList } = await getSelectPlanFn({needAudit: 11});
      this.selectList[0].data = planList;
      this.requestForm.planId = planList[0].id;
      this.planName = planList[0].name;
    },

    // 查询考前设置
    async getPlanExamConfig() {
      const { data: configData} = await getPlanExamConfigAPI({ planId: this.requestForm.planId });
      const { data: planInfo} = await getSinglePlan({ planId: this.requestForm.planId });
      this.isShowSubCourseFlag = planInfo.haveCourseSub;
      if (configData) {
        for (let key in configData) {
          if (this.form.hasOwnProperty(key)) {
            this.form[key] = configData[key];
          }
          if (this.noticeForm.hasOwnProperty(key)) {
            this.noticeForm[key] = configData[key];
          }
          this.examBackgroundImageUrl = configData.examBackgroundImageUrl;
        }
      } else {
        for (let key in this.form) {
          this.form[key] = null;
        }
        this.form.allowSignStateTimeByAfter = 60;
        this.form.allowSignStateTimeByBefore= 60;
        this.form.isSignStateOverTime = 1;
        this.form.isAllowedToSignWithoutIDCard = 1;
        this.form.isSignStateByImageRecognition = 1;
        this.form.isAllowExamByFaceRecognitionNoPass = 1;
        this.form.imageRecognitionTimes = 1;
        this.form.submitPaperShowScoreForSubjective = 1;
        this.form.submitPaperShowScoreForSingle = 0;
        for (let key in this.noticeForm) {
          this.noticeForm[key] = null;
        }
        this.noticeForm.noticeBtnText = "确定";
        this.examBackgroundImageUrl = null;
      }

      this.noticeForm.noticeTitle = this.noticeForm.noticeTitle ? this.noticeForm.noticeTitle: "考试须知";
      this.noticeForm.commitmentTitle = this.noticeForm.commitmentTitle ? this.noticeForm.commitmentTitle: "考试承诺书";
      this.noticeForm.noticeCountdownTime = this.noticeForm.noticeCountdownTime ? this.noticeForm.noticeCountdownTime: 10;
      this.noticeForm.commitmentCountdownTime = this.noticeForm.commitmentCountdownTime ? this.noticeForm.commitmentCountdownTime: 10;
    },

    // 保存考试基础设置
    async examSetSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let params = {...this.form};
          params.planId = this.requestForm.planId;
          const { code } = await saveExamConfigOneAPI(params);
          if (code === 1) {
            this.$message.success("考试基础设置 -- 保存成功！");
          }
        } else {
          return false;
        }
      });
    },

    // 保存考试须知
    async NoticeSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.noticeForm.isShowNotice && !this.noticeForm.noticeContent) {
            this.$message.error("请输入考试须知内容！");
            return;
          }
          if (this.noticeForm.isShowCommitment && !this.noticeForm.commitment) {
            this.$message.error("请输入考试承诺书内容！")
            return;
          }
          let params = {...this.noticeForm};
          params.planId = this.requestForm.planId;
          const { code } = await saveExamConfigTwoAPI(params);
          if (code === 1) {
            this.$message.success("考试须知、承诺书 -- 保存成功！");
          }
        } else {
          return false;
        }
      });
    },

    // 保存背底图片
    async uploadBackground() {
      let params = {
        planId: this.requestForm.planId,
        url: this.examBackgroundImageUrl
      }
      let url = JSON.parse(JSON.stringify(this.examBackgroundImageUrl)).split(",");
      if (url.length > 1) {
        params.url = url[1];
      }
      const { code } = await saveExamConfigThreeAPI(params);
      if (code === 1) {
        this.$message.success("考试机背底图片 -- 上传成功！");
      }
    },

    // 上传文件格式处理
    uploadImgUrl(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.examBackgroundImageUrl = e.currentTarget.result;
        }
      };
    },

    // 背底图片格式校验
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpg，jpeg，png 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isJPG && isLt2M;
    },

    // 复制上个考试批次
    async copyPrevious() {
      let { planId } = this.requestForm;
      const { code } = await copyExamConfigAPI({ planId });
      if (code === 1) {
        this.$message.success("复制成功！");
      }
      this.getPlanExamConfig();
    },

    // 查询 (批次改变)
    search() {
      this.getPlanExamConfig();
    },

    // 预览
    showIt() {
      let query = {
        imgUrl: this.examBackgroundImageUrl,
        planName: this.planName
      }
      let routeUrl = this.$router.resolve({name: 'previewPreExam',query})
      window.open(routeUrl.href, '_blank')
    },
  },
}
</script>

<style lang="less" scoped>
.noUser{ 
  user-select: none;
}
.cards {
  margin-top: 8px;
}
.title {
  margin-bottom: 16px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

/deep/ .el-form-item__content {
  .el-radio-group {
    padding-top: 8px;
    box-sizing: border-box;
    margin: auto;
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 360px;
  height: 360px;
  line-height: 360px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  box-sizing: border-box;
}
.avatar {
  width: 360px;
  height: 360px;
  display: block;
  position: relative;
}
h3 {
  margin-bottom: 16px;
}
/deep/ .el-radio__original {
  display: none !important;
}
 
/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
.machineTip{
  color: #F56C6C;
  margin-left: 14px;
}
</style>